module.exports = __webpack_public_path__ + "img/astral_1.98160383.svg";